import api from "../api/api";

// The ONE existing, public, unauthenticated guest-quote endpoint. Its
// request/response shape is exactly what routers/guest_requests.py
// defines — no field here is invented. It intentionally accepts no
// "preferred delivery date/time" or "company name" (the backend has no
// such columns); adding them to the payload would just be silently
// dropped or rejected by FastAPI's own validation, so they aren't sent.
//
// Used for BOTH guest and logged-in customers — there is no separate
// customer-scoped quote endpoint. A logged-in customer's request still
// gets created with customer_id=None server-side (confirmed in the
// handler), so it will not appear in any "my quotes" view — because no
// such view exists on the backend at all (quotations are staff_only).
export async function createQuoteRequest({
  customerName,
  phone,
  email,
  shippingAddress,
  note,
  items, // [{ product_id, unit_code, qty_ordered }]
}) {
  const res = await api.post("/guest/quotation-requests", {
    customer_name: customerName,
    phone: phone || null,
    email: email || null,
    shipping_address: shippingAddress || null,
    note: note || null,
    items,
  });
  return res.data; // { qtn_code, status, item_count, created_at } — never a price field
}

// POST /guest/quotation-requests/lookup — follow-up on a submitted request.
// Requires the QTN code plus the phone OR email given at submission; the
// backend answers 404 for any mismatch and never returns prices.
export async function lookupQuoteRequest({ qtnCode, phone, email }) {
  const res = await api.post("/guest/quotation-requests/lookup", {
    qtn_code: qtnCode,
    phone: phone || null,
    email: email || null,
  });
  return res.data; // { qtn_code, status, created_at, items: [{product_name, unit_code, qty_ordered}] }
}

// True only for the backend's own "no matching request" answer. A bare 404 (e.g. an older API that does not
// have the lookup route yet, whose detail is just "Not Found") must NOT be shown to the customer as "no match".
export function isNoMatch(err) {
  return err?.response?.status === 404 && /no matching/i.test(String(err.response?.data?.detail || ""));
}
